import {PaymentCodeEnum, PayoutWebModel} from "capitalist-shared/src/finance/payments";

export class CapitalistChequeModel extends PayoutWebModel {
  systemName = PaymentCodeEnum.CapitalistCheque

  values = {
    email: '', fromAccount: '', amount: '', verificationType: '',
    sendNotification: false, description: '',
    autosplit: false
  }
}
